import reactiveData from './reactiveData.js'
import reactiveProp from './reactiveProp.js'

export default {
  reactiveData,
  reactiveProp
}



// WEBPACK FOOTER //
// ./src/mixins/index.js